import React, { Suspense, lazy, useMemo } from 'react';

import * as animationData from 'assets/animations/success-tick.json';
import * as motion from 'motion/react-client';
import { useSearchParams } from 'react-router-dom';

import styles from './FormThanksCard.module.scss';

const Lottie = lazy(() => import('react-lottie'));
export const FormThanksCard = ({ candidate, fullHeight = true }) => {
  const [searchParams] = useSearchParams();
  const only_info = searchParams.get('only_info') === 'true';
  const already_submitted = searchParams.get('already_submitted') === 'true';

  const lottieOptions = useMemo(
    () => ({
      loop: false,
      autoplay: true,
      animationData: animationData,
    }),
    [],
  );

  return (
    <div className={`${styles.root} ${fullHeight ? styles.fullHeight : ''}`}>
      <div className={styles.top}>
        <Suspense fallback={<div>Loading...</div>}>
          <Lottie key="form-thanks-lottie" width={160} options={lottieOptions} />
        </Suspense>
        {candidate ? (
          <div
            className="u-font-size-xxxx-large u-font-weight-400"
            data-testid="submission-success-message">
            {already_submitted
              ? "You've already submitted — we have everything we need!"
              : only_info
                ? 'Thank you, All the best!'
                : 'Thank you, your information was submitted successfully'
                    .split(' ')
                    .map((word, index) => (
                      <motion.span
                        key={index}
                        initial={{ opacity: 0, y: -20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{
                          duration: 0.2,
                          delay: index * 0.1,
                        }}
                        style={{ display: 'inline-block', marginRight: '0.3em' }}>
                        {word}
                      </motion.span>
                    ))}
          </div>
        ) : (
          <>
            <div className="u-font-size-xxxx-large u-font-weight-400 u-width-75">
              {'Thank you!'.split(' ').map((word, index) => (
                <motion.span
                  key={index}
                  initial={{ opacity: 0, y: -20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{
                    duration: 0.5,
                    delay: index * 0.1,
                  }}
                  style={{ display: 'inline-block', marginRight: '0.3em' }}>
                  {word}
                </motion.span>
              ))}
            </div>
            <span
              className="u-font-size-large secondary-text"
              data-testid="referee-submission-success-message">
              Your reference has been submitted successfully. We will take it from here.
            </span>
          </>
        )}
      </div>
      <div className={styles.bottom}>
        <div>Powered by</div>
        <motion.span
          initial={{ opacity: 0, scale: 0.2 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{
            duration: 0.5,
            type: 'spring',
            stiffness: 100,
            damping: 10,
          }}
          style={{ display: 'inline-block', marginRight: '0.3em' }}>
          <img src="assets/images/checkmate/icon-label.svg" alt="checkmate" />
        </motion.span>
      </div>
    </div>
  );
};
